// Money convention (matches the backend): all amounts are integer cents USD
// (`*CentsUSD`), exact with no floating-point rounding. Dollars are used only for
// display (here) and for parsing admin form input.

/** Format integer cents as a USD string, e.g. 1299 -> "$12.99". */
export function formatCentsUSD(centsUSD: number): string {
  return `$${(centsUSD / 100).toFixed(2)}`;
}

/** Parse a human-entered dollar amount into integer cents, e.g. 12.99 -> 1299. */
export function dollarsToCents(dollarsUSD: number): number {
  return Math.round(dollarsUSD * 100);
}

/** Integer cents -> dollars number (for prefilling a dollar input), e.g. 1299 -> 12.99. */
export function centsToDollars(centsUSD: number): number {
  return centsUSD / 100;
}
